import React from 'react';
import { useSelector } from 'react-redux';
import { DivestitureDiagnosticUtility } from '@pwc/pwc-deals-web-common';
import {
  getDivestitureDiagnosticResults,
  getEditMode,
} from '../../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import Description from '../Description/Description';

import './Overview.scss';
import ScoreView from '../ScoreView/ScoreView';
import ScoreTextInput from '../../ScoreTextInput/ScoreTextInput';
import ComplexityScaleWrapper from '../../ComplexityScaleWrapper/ComplexityScaleWrapper';

const Overview = ({
  category,
  children,
  onScoreChange,
  onDescriptionChange,
}) => {
  const isEditMode = useSelector(getEditMode);

  const results = useSelector(getDivestitureDiagnosticResults);
  const categoriesWithOverall = [
    results.overallDealComplexity,
    ...results.data,
  ];
  const thisCategory = categoriesWithOverall.find(
    (cat) => cat.categoryId === category.categoryId
  );

  return (
    <>
      <div className="category-overview-caption">
        <p className="dd-category-title">{category.title}</p>
        <Description description={category.categoryCaption} />
      </div>
      <div className="category-overview-score-wrapper">
        <div className="dd-category-score">
          {!isEditMode && <ScoreView category={category} />}
          {isEditMode && (
            <>
              <span className="dd-category-score-text">
                {DivestitureDiagnosticUtility.calculateScoreText(
                  category.value
                )}
              </span>
              <ScoreTextInput
                category={category}
                onScoreChange={onScoreChange}
              />
            </>
          )}
        </div>
        {thisCategory && (
          <ComplexityScaleWrapper
            initial={thisCategory.initialValue}
            modified={thisCategory.value}
            backgroundColor="color-page-background"
            highLow
            showTooltip
          />
        )}
        <Description
          description={category.description}
          onDescriptionChange={onDescriptionChange}
          isDescriptionEditable
        />
      </div>
      {children && <div className="category-overview-content">{children}</div>}
    </>
  );
};

export default Overview;
